import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import manageProfileService from "./manageProfileService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { validEmail, validPassword } from "../../../common/utils";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
// import user from '../../../mokup_ListaUser'

toast.configure();

class manageProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataTableSanzione: [],
      dataTableSanzioneCSV: [],
      csvFile: [],
      headerDataTableSanzione: [],
      searchNumSanzione: "",
      searchDataEmissione: "",
      searchNome: "",
      searchCognome: "",
      searchCF: "",
      loading: true,
      showModalModificaUser: false,
      selectRoleOption: false,
      isErrornumMatricola: false,
      isErrorPassword: false,
      isErrorEmail: false,
      isErrorNome: false,
      isErrorCognome: false,
      showPassword:false,
      isErrorRuolo: false,
      userController: {
        codiceFiscale: "",
        nome: "",
        cognome: "",
        email: "",
        numMatricola: "",
        password: "",
        telefono: "",
        ruoliOperatori: {
          idAnagraficaRuoloOperatore: "",
          nomeRuolo: "",
        },
        loadingButton:false,
      },
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    const emailRegex = /^\S+@\S+\.\S+$/;
    this.nameRegex = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(?: [A-Za-zÀ-ÖØ-öø-ÿ]+)*$")
    this.matricolaRegex = new RegExp("^[A-Za-z0-9]{4,}$")
  }

  componentDidMount() {
    this.dashboardSanzioneService = new manageProfileService();
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getDataTable(stato);
  }

  getDataTable(stato) {
    this.dashboardSanzioneService.getDataTableSanzioni(
      stato,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }
  sectionInput(event) {
    // this.setState({ selectRoleOption: false });
    // console.log(event.target.value);
    this.setState({ selectRoleOption: false });
    this.state.userController.ruoliOperatori.nomeRuolo = event.target.value;
    this.state.userController.ruoliOperatori.idAnagraficaRuoloOperatore =
      parseInt(event.target.value);
    this.setState({ userController: this.state.userController });
  }
  modificaUser() {
    this.setState({ isErrorPassword: false });
    this.setState({ showModalModificaUser: true });
  }
  AnnulaModificaUser() {
    this.state.userController.ruoliOperatori.nomeRuolo = ""
    this.state.userController.ruoliOperatori.idAnagraficaRuoloOperatore = 0
    this.state.userController.codiceFiscale = ""
    this.state.userController.cognome = ""
    this.state.userController.nome = ""
    this.state.userController.password = ""
    this.state.userController.email = ""
    this.state.userController.numMatricola = ""
    this.state.userController.telefono = ""
    // this.setState({ userController: [] });
    this.setState({ isErrorCognome: false });
    this.setState({ isErrornumMatricola: false });
    this.setState({ isErrorEmail: false });
    this.setState({ isErrorNome: false });
    this.setState({ isErrorRuolo: false });
    this.setState({ isErrorPassword: false });
    this.setState({ showModalModificaUser: false });
    this.setState({ selectRoleOption: false });
  }

  confermaModificaUser() {
    if (!this.matricolaRegex.test(this.state.userController.numMatricola)) {
      this.setState({ isErrornumMatricola: true });
    } else {
      this.setState({ isErrornumMatricola: false });
    }

    this.setState({ isErrorEmail: false });
    if (!validEmail.test(this.state.userController.email)) {
      this.setState({ isErrorEmail: true });
    } else {
      this.setState({ isErrorEmail: false });
    }

    this.setState({ isErrorPassword: false });
    if (!validPassword.test(this.state.userController.password)) {
      this.setState({ isErrorPassword: true });
    } else {
      this.setState({ isErrorPassword: false });
    }

    if (!this.nameRegex.test(this.state.userController.nome)) {
      this.setState({ isErrorNome: true });
    } else {
      this.setState({ isErrorNome: false });
    }

    if (!this.nameRegex.test(this.state.userController.cognome)) {
      this.setState({ isErrorCognome: true });
    } else {
      this.setState({ isErrorCognome: false });
    }
    // console.log(this.state.userController.ruolo)
    if (this.state.userController.ruoliOperatori.nomeRuolo >= "0") {
      this.setState({ selectRoleOption: false });
    } else {
      this.setState({ selectRoleOption: true });
    }
    if(this.nameRegex.test(this.state.userController.nome) && this.nameRegex.test(this.state.userController.cognome) && this.matricolaRegex.test(this.state.userController.numMatricola) && validPassword.test(this.state.userController.password)  && validEmail.test(this.state.userController.email)  && this.state.userController.ruoliOperatori.nomeRuolo >="0"){
      this.setState({ loadingButton:true})
      this.dashboardSanzioneService.saveUserIsert(
        this.state.userController,
        (result) => {
          this.setState({loadingButton:false})
          // console.log(result);
          if (result.status === 200 && result.data) {
            this.getDataTable("");
            this.state.userController.ruoliOperatori.nomeRuolo = ""
            this.state.userController.ruoliOperatori.idAnagraficaRuoloOperatore = 0
            this.state.userController.codiceFiscale = ""
            this.state.userController.cognome = ""
            this.state.userController.nome = ""
            this.state.userController.password = ""
            this.state.userController.email = ""
            this.state.userController.numMatricola = ""
            this.state.userController.telefono = ""
            this.setState({
              showModalModificaUser: false,
              // userController: [],
              isErrorCognome: false,
              isErrornumMatricola: false,
              isErrorEmail: false,
              isErrorRuolo: false,
              isErrorNome: false ,
              isErrorPassword: false,
              selectRoleOption: false,
            });
            toast.success("Utente Aggiunto", {
              position: toast.POSITION.TOP_RIGHT,
            });
            this.getDataTable("");
          } else {
            this.state.userController.ruoliOperatori.nomeRuolo = ""
            toast.error("Qualcosa è andato Storto", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      );
    }
    
    //TODO controllo dei dati inseriti dal utente e invio in post per aggiungere nuovo utente
  }
  modalModificaUser() {
    return (
      <>
        <Modal show={this.state.showModalModificaUser}>
          <Modal.Header>
            <Modal.Title>Aggiungi Utente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <fieldset className="border p-2">
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  idendificativi
                </legend>
                <div className="row">
                  <div className="col-sm">
                    <div className="col-sm">Numero matricola</div>
                    <input
                      className="form-control"
                      type="text"
                      required={true}
                      value={this.state.userController.numMatricola}
                      onChange={this.changeTextnumMatricola.bind(this)}
                    ></input>
                    {this.state.isErrornumMatricola ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo numero matricola deve contenere almeno 4
                            caratteri, sono accettati solo lettere e numeri
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm">
                    <div className="col-sm">Password</div>
                    <InputGroup>
                      <input
                        required={true}
                        className="form-control"
                        type={this.state.showPassword ? "text" : "password"}
                        value={this.state.userController.password}
                        onChange={this.changeTextPassword.bind(this)}
                      ></input>
                      <Button onClick={()=>this.setState({showPassword:!this.state.showPassword})}>
                        {this.state.showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-slash-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                          </svg>
                        )}
                      </Button>
                    </InputGroup>
                    {this.state.isErrorPassword ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "10px" }}>
                          <li>
                            La password deve essere più lunga di 8 caratteri
                          </li>
                          <li>
                            La password deve contenere almeno un carattere
                            speciale
                          </li>
                          <li>
                            La password deve contenere almeno una maiuscola
                          </li>
                          <li>
                            La password deve contenere almeno una minuscola
                          </li>
                          <li>La password deve contenere un numero</li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </fieldset>
              <legend className="w-auto" style={{ color: "#4e73df" }}>
                Anagrafica
              </legend>
              <div className="row">
                <div className="col-sm-4">Nome</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    required={true}
                    value={this.state.userController.nome}
                    onChange={this.changeTextNome.bind(this)}
                  ></input>
                  {this.state.isErrorNome ? (
                    <small className="text-danger">
                      Il campo nome deve contenere almeno 2 caratteri{" "}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Cognome</div>
                <div className="col-sm-8">
                  <input
                    required={true}
                    className="form-control"
                    type="text"
                    value={this.state.userController.cognome}
                    onChange={this.changeTextCognome.bind(this)}
                  ></input>
                  {this.state.isErrorCognome ? (
                    <small className="text-danger">
                      Il campo cognome deve contenere almeno 2 caratteri
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">E-mail</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    required={true}
                    type="email"
                    value={this.state.userController.email}
                    onChange={this.changeTextEmail.bind(this)}
                  ></input>
                  {this.state.isErrorEmail ? (
                    <small className="text-danger">E-mail non valida</small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Ruolo</div>
                <div className="col-sm-8">
                  <select
                    required={true}
                    onChange={this.sectionInput.bind(this)}
                    className="form-select"
                  >
                    {/* <option
                      value={this.state.userController.ruolo}
                      className={`${
                        this.state.selectRoleOption ? "" : "d-none"
                      }`}
                    >
                      Ruolo operatore
                    </option> */}
                    <option selected value={"Role"}>
                      Ruolo operatore
                    </option>
                    <option value={"0"}>verificatore</option>
                    <option value={"2"}>operatore avanzato</option>
                    <option value={"4"}>admin</option>
                  </select>
                  {this.state.selectRoleOption ? (
                    <small className="text-danger">Ruolo non selezionato</small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </fieldset>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaModificaUser.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.confermaModificaUser.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner /> : "Aggiungi Utente"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  //idendificazione controllore
  changeTextnumMatricola(event) {
    // this.setState({isErrornumMatricola:false})
    // if(this.state.userController.numMatricola.length === 0){
    //   this.setState({isErrornumMatricola:true})
    // }else{
    //   this.setState({isErrornumMatricola:false})
    // }this.setState({ isErrorCognome: false });
    this.setState({ isErrornumMatricola: false });
    this.state.userController.numMatricola = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextEmail(event) {
    this.setState({ isErrorEmail: false });
    if (!validEmail.test(this.state.userController.email)) {
      this.setState({ isErrorEmail: true });
    } else {
      this.setState({ isErrorEmail: false });
    }
    this.state.userController.email = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  //idendificazione controllore

  //anagrafica controllore
  changeTextNome(event) {
    this.setState({ isErrorNome: false });

    this.state.userController.nome = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextCognome(event) {
    this.setState({ isErrorCognome: false });

    this.state.userController.cognome = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextTelefono(event) {
    this.state.userController.telefono = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextCF(event) {
    this.state.userController.codiceFiscale = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextPassword(event) {
    this.setState({ isErrorPassword: false });
    this.state.userController.password = event.target.value;
    this.setState({ userController: this.state.userController });
    if (!validPassword.test(this.state.userController.password)) {
      this.setState({ isErrorPassword: true });
    } else {
      this.setState({ isErrorPassword: false });
    }
  }
  changeTextRuolo(event) {
    // if (this.state.userController.ruolo === "Role") {
    //   this.setState({ selectRoleOption: true });

    // }else{
    //   this.setState({ selectRoleOption: true });
    //   this.setState({ isErrorRuolo: false });
    // }
    this.setState({ selectRoleOption: false });
    // this.setState({ isErrorRuolo: true });
    this.state.userController.ruoliOperatori.nomeRuolo = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  changeTextPlafond(event) {
    this.state.userController.plafond = event.target.value;
    this.setState({ userController: this.state.userController });
  }
  //anagrafica controllore

  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var moment = require("moment");
    var numSanzioniInscadenza = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );
        allaScadenza = 60 - parseInt(diff, 10);
        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }
        sanzione.giorniAllaScadenza = val;
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    this.setState((this.headerDataTableSanzione = resultHeader));
    this.setState({ dataTableSanzioneCSV: resultBody });
    this.setState({ dataTableSanzione: resultBody });
    this.setState({ loading: false });
    this.setState({csvFile:[]});
    resultBody.map((dati) => {
      this.state.csvFile = [
        ...this.state.csvFile,
        {
          nome: dati.nome,
          cognome: dati.cognome,
          numMatricola: dati.numMatricola,
          email: dati.email,
          ruolo: dati.ruolo,
          idAnagraficaOperatore: dati.idAnagraficaOperatore,
        },
      ];
    });

    this.setState({ csvFile: this.state.csvFile });
  }

  onRowClick(row) {
    sessionStorage.removeItem("userControllore");
    sessionStorage.setItem("userControllore", JSON.stringify(row));
    // console.log(row);//dati della righa da passare
    this.props.history.push("/detailProfile");
  }

  dataObj() {
    for (const item of this.state.dataTableSanzione) {
      item.clickEvent = () => this.onRowClick(item);
    }
    var data = {
      columns: this.headerDataTableSanzione,
      rows: this.state.dataTableSanzione,
    };
    return data;
  }

  renderTableData() {
    if (
      this.state.dataTableSanzione &&
      this.state.dataTableSanzione.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                infoLabel={["Mostra da", "a", "di", "utenti totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return <tr> Nessun dato, effettua una ricerca.</tr>;
    }
  }

  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Utenti<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Impostazioni &#8594; Utenti
              </small>
            </h1>
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.modificaUser.bind(this)}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              utente
            </button>
            <CSVLink
              data={this.state.csvFile}
              separator={";"}
              filename="utenti.csv"
            >
              <button type="button" class="btn btn-warning">
                {" "}
                <i className="fas fa-download fa-sm text-white"></i>{" "}
                &nbsp;Esporta Utenti
              </button>
            </CSVLink>
          </div>
          <br />
          <br />
          <div className="col">{this.renderTableData()}</div>
          {this.modalModificaUser()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(manageProfile);
